import Component from '../abstracts/Component';

export default class CardComponent extends Component {

  get SELECTORS() {
    return {
      main: '.widget-wrapper .card',
      toggler: '.show-more'
    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();

    this.main = $(this.SELECTORS.main);
    this.toggler = $(this.SELECTORS.toggler);

  }

  showMore() {
    this.$on('click.showMore', ({event}) => {
      event.preventDefault();
      let target = event.target;
      target.classList.toggle('opened');
      let targetContainer = $(target).closest('figcaption');


      if($(target).parents('.c-media') != null){
        targetContainer.find('.p-editorial')
          ? targetContainer.find('.p-editorial').slideToggle()
          : null;
        targetContainer.find('.cta-editorial')
          ? targetContainer.find('.cta-editorial').slideToggle().toggleClass('visible')
          : null;
      } else {
        if (!$(target).closest('.c-component').hasClass('c-twin')) {
          targetContainer.find('h2.h2-editorial-primary')
            ? targetContainer.find('h2.h2-editorial-primary').slideToggle()
            : null;
        } else if ($(target).closest('.c-component').hasClass('c-twin')) {
          targetContainer.find('h2.h1-editorial')
            ? targetContainer.find('h2.h1-editorial').slideToggle()
            : null;
        }

        targetContainer.find('p')
          ? targetContainer.find('p').slideToggle()
          : null;
        targetContainer.find('.cta-editorial')
          ? targetContainer.find('.cta-editorial').slideToggle().toggleClass('visible')
          : null;
      }
    }, this.toggler)
  }

  bindEvents() {
    this.showMore();
  }

  render() {
    this.bindEvents();
  }
}
